import { render } from "./HorizontalRule.vue?vue&type=template&id=49a13847"
import script from "./HorizontalRule.vue?vue&type=script&lang=js"
export * from "./HorizontalRule.vue?vue&type=script&lang=js"

import "./HorizontalRule.vue?vue&type=style&index=0&id=49a13847&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__